import { MovimientoBancarioGetConciliacionBancariaByIdDtoProps } from "api/DTOs/MovimientoBancarioGetConciliacionBancariaByIdDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const MODAL_DOCUMENTOS_CUENTAS_BANCARIAS_CONCILIADAS_COLUMNS = (
  t: TFunction
) => [
  {
    key: "fecha",
    field: "fecha",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerDate"
    )}`,
    style: { width: "20%" },
    body: ({ fecha }: MovimientoBancarioGetConciliacionBancariaByIdDtoProps) =>
      fecha ? frontendDateFormat(new Date(fecha)) : "-",
  },
  {
    key: "concepto",
    field: "concepto",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerConcept"
    )}`,
    style: { width: "50%" },
  },
  {
    key: "importe",
    field: "importe",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerAmount"
    )}`,
    body: ({
      importe,
    }: MovimientoBancarioGetConciliacionBancariaByIdDtoProps) =>
      frontendCurrency(importe),
    bodyClassName: "!tw-text-end",
    alignCol: "right",
    width: "30%",
  },
]

export const MODAL_DOCUMENTOS_CUENTAS_BANCARIAS_CONCILIADAS_COLUMNS_OLD = (
  t: TFunction
) => [
  {
    key: "fecha",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerDate"
    )}`,
    dataIndex: "fecha",
    className: "tw-text-base !tw-pl-6 [&>*_td]:!tw-py-0",
    render: (cell: string) => frontendDateFormat(new Date(cell)),
    width: "50%",
  },
  {
    key: "concepto",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerConcept"
    )}`,
    dataIndex: "concepto",
    className: "tw-text-base [&>*_td]:!tw-py-0",
    width: "50%",
  },
  {
    key: "importe",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedMovementsTable.headerAmount"
    )}`,
    render: (cell: number) => frontendCurrency(cell),
    dataIndex: "importe",
    className: "tw-text-base tw-text-right !tw-pr-8 [&>*_td]:!tw-py-0",
    width: "50%",
  },
]
